import { ListPage } from '@components/molecules';
import { TextFieldElement } from 'react-hook-form-mui';
import API from '@apps/localization/services/region';
import { ModelProps } from '@/types';
import {
  RegionSchema,
  RegionSearchSchema,
} from '@apps/localization/schemas/region';
import { GridColDef } from '@mui/x-data-grid';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { YesNoAutocompleteElement } from '@/components/atoms';

export default function ObjectListPage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: t('Name'),
      flex: 1,
    },
    {
      field: 'is_active',
      headerName: t('Is Active?'),
      width: 120,
      type: 'boolean',
    },
  ];

  return (
    <ListPage
      schema={RegionSchema}
      schemaSearch={RegionSearchSchema}
      title={t('Region')}
      api={API}
      columns={columns}
      modelProps={modelProps}
      initialState={{
        sorting: {
          sortModel: [{ field: 'name', sort: 'asc' }],
        },
      }}
    >
      <Grid size={{ xs: 12, md: 3 }}>
        <TextFieldElement name="search" label={t('Search')} fullWidth />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <YesNoAutocompleteElement name="is_active" label={t('Is Active?')} />
      </Grid>
    </ListPage>
  );
}
